import React from "react";
import TextField from "@material-ui/core/TextField";
import MuiThemeProvider from "@material-ui/core/styles/MuiThemeProvider";
import { createMuiTheme } from "@material-ui/core/styles";
import { TextValidation } from "./styled.components";

export default class FrmNewUser extends React.Component {
  componentDidUpdate(prevProps, prevState) {
    //console.log(prevProps, prevState)
  }
  render() {
    const { errors } = this.props;
    const formLabelsTheme = createMuiTheme({
      overrides: {
        MuiFormLabel: {
          asterisk: {
            color: "#db3131",
            "&$error": {
              color: "#db3131",
            },
          },
        },
      },
    });

    const style = {
      margin: "5px",
    };

    return (
      <MuiThemeProvider style={{ display: "flex" }} theme={formLabelsTheme}>
        <div className="ARC_Lgn_dv">
          <div
            style={{
              display: "flex",
              justifyContent: "left",
              flexDirection: "column",
              alignItems: "flex-start",
            }}
          >
            <TextField
              style={style}
              id="nombre"
              label="Nombre"
              fullWidth
              lineDirection="center"
              className="lg-cell lg-cell--bottom"
              required
            />
            {errors.nombre ? (
              <TextValidation>{errors.nombre}</TextValidation>
            ) : (
              ""
            )}
          </div>
          <div className="dv_fluid">
            <div
              style={{
                display: "flex",
                justifyContent: "left",
                flexDirection: "column",
                alignItems: "flex-start",
              }}
            >
              <TextField
                style={style}
                id="apellidoPaterno"
                label="Apellido Paterno"
                lineDirection="center"
                className="lg-cell lg-cell--bottom"
                required
              />
              {errors.apellidoPa ? (
                <TextValidation>{errors.apellidoPa}</TextValidation>
              ) : (
                ""
              )}
            </div>
            <div
              style={{
                display: "flex",
                justifyContent: "left",
                flexDirection: "column",
                alignItems: "flex-start",
              }}
            >
              <TextField
                style={style}
                id="apellidoMaterno"
                label="Apellido Materno"
                lineDirection="center"
                className="lg-cell lg-cell--bottom"
                required
              />
              {errors.apellidoMa ? (
                <TextValidation>{errors.apellidoMa}</TextValidation>
              ) : (
                ""
              )}
            </div>
          </div>
          <div className="dv_fluid">
            <div
              style={{
                display: "flex",
                justifyContent: "left",
                flexDirection: "column",
                alignItems: "flex-start",
              }}
            >
              <TextField
                style={style}
                id="codigoPostal"
                label="Código Postal"
                lineDirection="center"
                type="number"
                className="lg-cell lg-cell--bottom"
                maxLength={5}
                required
              />
              {errors.codigoP ? (
                <TextValidation>{errors.codigoP}</TextValidation>
              ) : (
                ""
              )}
            </div>
            <div
              style={{
                display: "flex",
                justifyContent: "left",
                flexDirection: "column",
                alignItems: "flex-start",
              }}
            >
              <TextField
                style={style}
                id="Telefono1"
                label="Celular"
                lineDirection="center"
                type="number"
                className="lg-cell lg-cell--bottom"
                required
              />
              {errors.tel ? <TextValidation>{errors.tel}</TextValidation> : ""}
            </div>
          </div>
          <div className="dv_fluid">
            <div
              style={{
                display: "flex",
                justifyContent: "left",
                flexDirection: "column",
                alignItems: "flex-start",
              }}
            >
              <TextField
                style={style}
                id="correo"
                label="Correo Electrónico"
                lineDirection="center"
                className="lg-cell lg-cell--bottom"
                required
              />
              {errors.correo ? (
                <TextValidation>{errors.correo}</TextValidation>
              ) : (
                ""
              )}
            </div>
            <div
              style={{
                display: "flex",
                justifyContent: "left",
                flexDirection: "column",
                alignItems: "flex-start",
              }}
            >
              <TextField
                style={style}
                id="vfcorreo"
                label="Verificación correo"
                lineDirection="center"
                className="lg-cell lg-cell--bottom"
                required
              />
              {errors.vfCorreo ? (
                <TextValidation>{errors.vfCorreo}</TextValidation>
              ) : (
                ""
              )}
            </div>
          </div>
          <div
            style={{
              display: "flex",
              justifyContent: "left",
              flexDirection: "column",
              alignItems: "flex-start",
            }}
          >
            <TextField
              style={style}
              id="IdPass"
              label="Contraseña"
              type="password"
              className="lg-cell lg-cell--bottom"
              required
            />
            {errors.contrasenia ? (
              <TextValidation>{errors.contrasenia}</TextValidation>
            ) : (
              ""
            )}
          </div>
        </div>
      </MuiThemeProvider>
    );
  }
}
